const getSuccessMessageByPageType = (authorData = {}) => {
  let message = []
  if (authorData.selfRegistrationFormFlag) {
    message = ["Thank you for registering with us."]
  } else if (authorData.siteRegistrationFormFlag) {
    message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  } else if (authorData.bathroomInspirationFormFlag) {
    message = ["Thank you for registering."]
  } else if (
    authorData.warrantyRegistrationFormFlag
  ) {
    message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  } else if( authorData.omniChannelKECFormFlag){
    message = [
      "Appointment booked successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  }

  return message
}
const getSuccessMessageByPageTypeService = (authorData = {}) => {
  let message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  return message
}

const getParamsByURL = (omniQRParams = {}) => {
  const { placementType, placementId, qrId, kaspId } = omniQRParams

  if (placementType && placementId && qrId) {
    return {
      campaignId: placementType === "ServiceCamp" || placementType === "Service Camp" ? placementId : "",
      kecId: placementType === "Kec" ? placementId : "",
      eventId: placementType === "Event" ? placementId : "",
      dealerId: placementType === "Dealer" ? placementId : "",
      technicianId: placementType === "ServiceTechnician"|| placementType === "Service Technician" ? placementId : "",
      qrId,
      leadSubSourceSegment: placementType === "ServiceTechnician" || placementType === "Service Technician"?"Service Technician":placementType === "ServiceCamp"||placementType === "Service Camp"?"Service Camp":"Dealer",
      kaspId: kaspId
    }
  }
  return {
    dealerId: "",
    qrId: "",
    leadSubSourceSegment: "",
    campaignId:"",
    technicianId:"",
    kaspId:""
  }
}

const getPageParamsByType = authorData => {
  if (authorData.selfRegistrationFormFlag) {
    return {
      pageName: "selfregistration",
      pageNamePascalCase: "SelfRegistration",
      pagenamehyphen: "self-registration",
      pageTitle: "Self Registration",
      contentType: "selfregistration",
    }
  } else if (authorData.bathroomInspirationFormFlag) {
    return {
      pageName: "bathroominspiration",
      pageNamePascalCase: "BathroomInspiration",
      pagenamehyphen: "bathroom-inspiration",
      pageTitle: "Bathroom Inspiration",
      contentType: "inspiration",
    }
  } else if (authorData.omniChannelKECFormFlag) {
    return {
      pageName: "kecappointment",
      pageNamePascalCase: "KECAppointment",
      pagenamehyphen: "kec-appointment",
      pageTitle: "KEC Appointment",
      contentType: "appointment",
    }
  } else if (authorData.warrantyRegistrationFormFlag) {
    return {
      pageName: "warrantyregistration",
      pageNamePascalCase: "WarrantyRegistration",
      pagenamehyphen: "warranty-registration",
      pageTitle: "Warranty Registration",
      contentType: "warranty",
    }
  } else if (authorData.siteRegistrationFormFlag) {
    return {
      pageName: "sitevisit",
      pageNamePascalCase: "SiteVisit",
      pagenamehyphen: "site-visit",
      pageTitle: "Site Visit",
      contentType: "sitevisit",
    }
  } else if (authorData.amcFormFlag) {
    return {
      pageName: "amc",
      pageNamePascalCase: "AMC",
      pagenamehyphen: "amc",
      pageTitle: "AMC",
      contentType: "amc",
    }
  } else if (authorData.serviceRequestFormFlag) {
    return {
      pageName: "servicerequest",
      pageNamePascalCase: "ServiceRequest",
      pagenamehyphen: "service-request",
      pageTitle: "Service Request",
      contentType: "servicerequest",
    }
  }
}

const getEventInfoForOtp = authorData => {
  const pageURL = window.location.href
  const {
    pageName = "",
    pageTitle = "",
    contentType = "",
  } = getPageParamsByType(authorData)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `omnichannel:${pageName}:otpvalidation:success`,
    eventName: `omnichannel:${pageName}:otpvalidation:success`,
    eventStatus: "success",
    eventMsg: `User OTP validation successful for ${pageTitle}  form`,
    eventType: "form_interaction",
    internalLinkName: "otp validation",
    internalLinkPosition: `${pageTitle} Form`,
    internalLinkType: `retail:${contentType}:otp`,
    internalLinkZoneName: `${pageTitle} Section`,
    internalLinkURL: pageURL,
    selectRating: "",
    selectOption: "",
  }
  return eventInfo
}

const getFormInfoForOtp = (data, authorData) => {
  const { firstName = "", lastName = "", mobileNumber = "" } = data || {}
  const { pageTitle = "" } = getPageParamsByType(authorData)
  return {
    form: {
      formName: "Lead Creation",
      formType: `Retail / ${pageTitle}`,
      formStatus: "otp_validated",
      formValues: {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: mobileNumber,
      },
    },
  }
}

const getEventInfoFormSubmit = (authorData, resultType) => {
  const pageURL = window.location.href
  const { pageNamePascalCase, pageTitle, contentType } =
    getPageParamsByType(authorData)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `omnichannel:landing:${pageNamePascalCase}:${resultType}`,
    eventName: `omnichannel:landing:${pageNamePascalCase}:${resultType}`,
    eventStatus: `${resultType}`,
    eventMsg: `Retail customer navigated to ${pageTitle} page`,
    eventType: "navigation",
    internalLinkName: `${pageTitle}`,
    internalLinkPosition: `Omnichannel Landing Page`,
    internalLinkType: `retail:${contentType}`,
    internalLinkZoneName: `${pageTitle} Section`,
    internalLinkURL: pageURL,
    selectRating: "",
    selectOption: "",
  }
  return eventInfo
}

const getFormInfoForSubmittion = (
  data = {},
  authorData = {},
  paramsByUrl = {}
) => {
  const { pageTitle } = getPageParamsByType(authorData)
  const {
    firstName,
    lastName,
    mobileNumber,
    email,
    pinCode,
    noOfBathroom,
    budget,
    purchasePick,
    whatsAppConsent,
    smsAppConsent,
    productCategory = "",
    siteAddress = "",
    productImages = [],
    fileType = "",
    state = "",
    city = "",
    kecCity = "",
  } = data
  const { campaignId, kecId, eventId, dealerId, qrId } = paramsByUrl
  return {
    form: {
      formName: "Lead Creation",
      formType: `Retail / ${pageTitle}`,
      formStatus: "initiated",
      formValues: {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: mobileNumber,
        email: email,
        pincode: pinCode,
        noOfBathrooms: noOfBathroom,
        budget: budget,
        expectedPurchase: purchasePick,
        whatsappOptIn: whatsAppConsent,
        otherOptIn: smsAppConsent,
        segment: "Retail",
        productCategory: productCategory,
        address: siteAddress,
        qrId: qrId,
        campaignId: campaignId,
        kecId: kecId,
        kecCity: kecCity,
        state: state,
        city: city,
        eventId: eventId,
        dealerId: dealerId,
        scanEventType: pageTitle,
        leadSubSourceSegment: "Omnichannel",
        leadType: "Retail",
        leadSource: "Omnichannel Landing",
        leadSubSource: pageTitle,
        leadStatus: "New",
        leadCurrency: "INR",
        appointment: {
          dateTime: "",
          slot: "",
          status: "",
          capacity: "",
        },
        warranty: {
          uploadFileType: fileType,
          source: productImages.length > 0 ? productImages[0] : "",
        },
        siteVisit: {
          symptom: "",
          callerNumber: "",
          callerType: "",
          callAllocationType: "",
        },
      },
    },
  }
}

const kecCityMapping = [
  { Bangalore: "KEC Bangalore" },
  { Delhi: "KEC Delhi" },
  { Mumbai: "KEC Mumbai" },
  { Ahmedabad: "Studio Ahmedabad" },
  { Hyderabad: "Studio Hyderabad" },
  { Chennai: "Studio Chennai" },
  { Pune: "Studio Pune" },
]

const getOmniCTAEventInfo = (pageTitle = "", buttonName = "") => {
  return {
    clickInternalLinks: "true",
    internalLinkPosition: `kohler-india:${pageTitle}`,
    internalLinkZoneName: `kohler-india:${pageTitle}`,
    internalLinkURL: `${window.location.href}`,
    internalLinkName: buttonName,
    eventName: `kohler-india:${pageTitle}:${buttonName}`,
    internalLinkType: "Other",
    eventType: "Button",
    eventAction: `kohler-india:${pageTitle}:${buttonName}`,
  }
}
const sessionStoreClosure = () => {
  let userDetailsRef = {
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    pinCode: '',
    city: '',
    state: ''
  }
  const acceptedAttributes = Object.keys(userDetailsRef)
  const filterAcceptedFormData = (_obj) =>{
    return Object.fromEntries(Object.entries(_obj).filter(([key]) => acceptedAttributes.includes(key)))
  }
  const addSessionUserDetails = function (qrId, formObj) {
    const filteredFormObj = filterAcceptedFormData(formObj)
    window.sessionStorage.setItem(`${qrId}`,JSON.stringify({...filteredFormObj}))
  }
  const getSessionUserDetails = function (qrId) {
    if(!qrId){
      return {}
    }
    let localStorage_userdata = JSON.parse(window.sessionStorage.getItem(qrId))
    if(localStorage_userdata){
      return {...localStorage_userdata}
    }else{
      return userDetailsRef
    }
  }
  return {
    addSessionUserDetails,
    getSessionUserDetails
  }
}

const { addSessionUserDetails, getSessionUserDetails } = sessionStoreClosure()

const getInitialDataValues = function (paramsByUrl) {
    const {
      qrId
    } = paramsByUrl
  const _session_userDetails = getSessionUserDetails(qrId)
  return {
    ..._session_userDetails,
    noOfBathroom: "",
    budget: "",
    whatsAppConsent: true,
    smsAppConsent: true,
    kecCity: "",
    purchasePick: "",
    productCategory: "",
    constructionType: "",
    siteAddress: "",
    customerImage: [],
    uploadedImage: [],
    reportIssue: "",
    alternateMobileNumber:"",
    landmark:"",
    slot:"",
    appointmentDate:""
  }
}

export {
  getSuccessMessageByPageType,
  getSuccessMessageByPageTypeService,
  getEventInfoForOtp,
  getFormInfoForOtp,
  getEventInfoFormSubmit,
  getFormInfoForSubmittion,
  getParamsByURL,
  kecCityMapping,
  getOmniCTAEventInfo,
  getInitialDataValues,
  sessionStoreClosure,
  addSessionUserDetails,
  getSessionUserDetails
}
